<template>
<div id="container" class="wassergeschichten">
    <div class="fullscreen_background">
        <img src="/static/assets/wassergeschichten/Hintergrund.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <!-- <div class="moeve z30 hovering">
        <img class="img" src="/static/assets/wassergeschichten/Moeve.png" />
    </div> -->

    <div class="Kolibri z30 hovering">
        <!-- <img class="img" src="/static/assets/wassergeschichten/Schwimmer.png" /> -->
        <img class="img" src="/static/assets/wassergeschichten/Tassala.png" />
    </div>
    <div class="baer z30">
        <img class="img" src="/static/assets/wassergeschichten/Sophia.png" />
    </div>
    <div class="lianen_joe z30">
        <img class="img hovering1" src="/static/assets/wassergeschichten/Neptun.png" />
    </div>
    <div class="hugi z30">
        <img class="img hovering2" src="/static/assets/wassergeschichten/Hugi.png" />
    </div>
	<div class="gigi z30">
        <img class="img hovering3" src="/static/assets/wassergeschichten/Gigi.png" />
    </div>
    <div class="dubix z30">
        <img class="img hovering4" src="/static/assets/wassergeschichten/Dubix.png" />
    </div>
    <div class="blubber blubber_animation z29">
    </div>
	<div class="wassergeist z30 wassergeist_animation">
    </div>
    <router-link to="/spacegeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/junglegeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/wassergeschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_2_Gigi_Anemonia.mp3" jsonurl="/static/assets/geschichten/gigi_19_3.timings.json" content=".wassergeschichten" target="wassergeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="wassergeschichten_target">
        <p>Es war Flut. Das Meer war zurück und mit ihm Gigi Anemonia. Jetzt lag sie in ihrem Versteck unter einem Steg am Strand. Ihr Vater Fürst Neptun und ihre Mutter Fürstin Talassa durften niemals wissen, dass sie an Land war. Denn Gigi Anemonia war eine Meeresprinzessin und ihr Platz war tief auf dem Meeresgrund im azurblauen Palast von Antalis. Die Insel Antalis war einst untergegangen und mit ihr die Bewohner und ihr Palast, der die schönsten Schätze barg, die je ein Lebewesen erblickte: Gold, Silber, Gemälde, ja sogar eine Bibliothek! Doch als vor langer Zeit der böse Wassergeist Sirenus den Palast und seine Bewohner beherrschte und ihnen strengstens untersagte zu lesen und das Lesen zu lehren, ging die hohe Kunst des Lesens in Antalis für immer verloren. Sie kehrte auch nicht wieder, als Sirenus endlich vertrieben worden war. </p>
<p>Schon von klein auf fragte sich Gigi Anemonia, was die Zeichen in den Büchern wohl bedeuteten. Sie und ihre Brüder Hugi Korallo und Dubix Atlantiko wollten es unbedingt herausfinden. Sie wussten, nur Erdbewohner konnten diese Zeichen erklären. Doch zu diesen war ihnen jeglicher Kontakt strikt verboten! Egal, sie wollten lesen lernen! Schwupp, da tauchten Hugi Korallo und Dubix Atlantiko aus dem Wasser auf. Aber oje! Wie ein Blitz stürzte sich da ein kleines wolliges Erdwesen auf die drei. Hinter ihm rief ein Erdmädchen: „Libero Mare, neiiin!“ Das wuselige Tier war so drollig, dass Gigi Anemonia und ihre Brüder jegliche Scheu verloren und einfach lachen mussten. Das Mädchen entschuldigte sich und erstarrte. Sie wollte schon laut „Hilfe, Wasserwesen!“ schreien, als sie sah, dass Libero Mare sich von der kleinen Nixe streicheln ließ. Das machte ihr Mut. „Wer seid ihr?“, stieß sie hervor. So erfuhr sie von Antalis und warum die drei an Land gekommen waren. „Kommt morgen wieder hierher!“, sagte sie. </p>
<p>Am nächsten Tag brachte Sophia Jansen, so hieß das Mädchen, Hefte, Stifte und eine Fibel mit und die ersten Bewohner von Antalis lernten wieder lesen. Von nun an kamen sie jeden Tag mit der Flut und gingen, bevor sich das Meer bei Ebbe ganz zurückzog. Bis sie eines Tages den Zeitpunkt verpassten. „Ach, du heilige Flosse!“, erschrak Dubix Atlantiko, „wie kommen wir jetzt ins Meer zurück?“ „Unsere Schuppenhaut wird austrocknen!“, rief Hugi Korallo. Hilfesuchend blickten die beiden ihre Schwester an, die unter ihrer blauen Nixenhaut erblasste. Winselnd schleckte Libero Mare sie ab und Sophia holte in ihrer Trinkflasche Wasser aus dem Meer, um ihre Freunde damit zu begießen. Doch das reichte nicht aus. Sie brachte Libero einen Eimer, den jemand im Sand vergessen hatte, und nun transportierte auch Libero Mare mit dem Eimerhenkel im Maul Wasser. Atem- und pausenlos liefen die zwei hin und her, aber den drei Wasserwesen ging es zunehmend schlechter. Plötzlich kam — huiii —vom Meer her starker Wind auf und eine Riesenwelle näherte sich dem Strand. Obendrauf thronte Fürst Neptun. Kurz vor den fünf Freunden stoppte die Welle, er schnappte sich seine Kinder und zog sie fort ins Meer. </p>
<p>Gab das ein Donnerwetter! Fürst Neptun versammelte seine Familie in der Bibliothek und schimpfte, weil seine Kinder sich so in Gefahr gebracht hatten. „Aber Papa“, weinte Gigi, „wir haben das für Antalis getan.“ „Quatsch!“, rief ihr Vater. Beherzt nahm Gigi Anemonia ein Buch aus dem Bücherregal und begann langsam zu lesen: „Die Abenteuer des Odysseus.“ Und sie las weiter und wurde immer besser. Als sie aufhören wollte, sagte ihr Vater: „Nein, nicht! Lies weiter, bitte!“ Fürst Neptun holte das ganze Haus zusammen, damit alle die spannende Geschichte von Odysseus hören konnten. Und so lasen Gigi und ihre Brüder, bis die Sonne tief im Meer versank. </p>
<p>Am nächsten Abend gab es im Palast ein großes Fest. Man feierte, dass die Kunst des Lesens nach Antalis zurückgekehrt war. Ehrengäste waren Sophia und Libero Mare, die ein Delfin in den Palast gebracht hatte. Bis tief in die Nacht tanzte, feierte und sang man:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'wassergeschichten',
  data () {
    return {
      who: 'wassergeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Gigi_Titel_Anemonia.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch (e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Unterwasser_Atmo_II.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* wassergeschichten */
.wassergeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.wassergeschichten .himmel { display: block !important; }

.wassergeschichten .geschichte { position: absolute; top: 170px; left:51%;  }

.wassergeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.wassergeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* wassergeschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.wassergeschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.wassergeschichten .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.wassergeschichten .fuchs_animation {
  width: 122px !important;
  height: 204px !important;
  background: url('/static/assets/wassergeschichten/Wassergeist_Animation.png') top center;
  animation: fuchs_animation 3s steps(15) infinite;
  animation-delay: 0.4s;
  transform: scale(1);
}
.wassergeschichten .baer {position: absolute; /* left: 36%; top: 74%; */ left: 773px; top: 4px;}
.wassergeschichten .baer {animation: baer_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes baer_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.wassergeschichten .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.wassergeschichten .lianen_joe {position: absolute; left: 270PX; bottom: 490PX;}
.wassergeschichten .lianen_joe {animation: lianen_joe_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes lianen_joe_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.wassergeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}
.wassergeschichten .hugi {position: absolute; right: 1208px; bottom: 585px;}
.wassergeschichten .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .wassergeschichten .dubix {position: absolute; left: 355px; bottom: 100px;}
.wassergeschichten .dubix {animation: hugi_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.wassergeschichten .Kolibri {position: absolute; right: 955px; bottom: 643px;}
.wassergeschichten .Kolibri {animation: schwimmen 0.5s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
  .wassergeschichten .gigi {position: absolute; left: 626px; bottom: 200px;}
.wassergeschichten .gigi {animation: dubix_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.wassergeschichten .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.wassergeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.wassergeschichten .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.wassergeschichten .hovering1 {
  -webkit-animation: hovering 18s linear infinite;
  -moz-animation: hovering 18s linear infinite;
  -ms-animation: hovering 18s linear infinite;
  -o-animation: hovering 18s linear infinite;
  animation: hovering 18s linear infinite;
}
.wassergeschichten .hovering2 {
  -webkit-animation: hovering 22s linear infinite;
  -moz-animation: hovering 22s linear infinite;
  -ms-animation: hovering 22s linear infinite;
  -o-animation: hovering 22s linear infinite;
  animation: hovering 22s linear infinite;
}
.wassergeschichten .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}
.wassergeschichten .hovering4 {
  -webkit-animation: hovering 24s linear infinite;
  -moz-animation: hovering 24s linear infinite;
  -ms-animation: hovering 24s linear infinite;
  -o-animation: hovering 24s linear infinite;
  animation: hovering 24s linear infinite;
}
/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.wassergeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/

.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}

.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}

.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}

.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}

.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}

.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}

.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}

/*************** SIMPLE INNER SCROLLBAR ***************/

.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}

.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}

.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}

.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}

.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}

.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}

.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}

.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69;
    box-shadow: inset 0 0 0px #ac8a69;
    -webkit-border-radius: 0;
    border-radius: 0;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69;
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69;
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}
.blubber.blubber_animation {
    top: -25%;
    left: -25%;
    position: absolute;
}
.blubber_animation {
  width: 2880px;
  height: 1620px;
  background: url('/static/assets/wassergeschichten/Blubber_Animation.png') top center;
  animation-delay: 1s;
  animation: blubber_animation 2s steps(6) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes blubber_animation {
    100% { background-position: 0 -9720px; }
}
.wassergeschichten .wassergeist {position: absolute; top: 871px; left: 10px;}
.wassergeist_animation {
  width: 122px;
  height: 204px;
  background: url('/static/assets/wassergeschichten/Wassergeist_Animation.png') top center;
  animation-delay: 1s;
  animation: wassergeist_animation 15s steps(15) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wassergeist_animation {
    0% { background-position: 0 -0px; }
    10% { background-position: 0 -3060px; }
    100% { background-position: 0 -3060px; }
}
span { font-family: FrozenMemory; }
.geschichte .player { top: 684px !important; }
.spacegeschichten .player {position: absolute !important;left: 95px !important;}
</style>



// WEBPACK FOOTER //
// src/components/Wassergeschichten.vue